import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-text-section-item',
  templateUrl: './text-section-item.component.html',
  styleUrls: ['./text-section-item.component.css']
})
export class TextSectionItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
